import {Component, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-list-filter-group',
  templateUrl: './list-filter-group.component.html',
  styleUrls: ['./list-filter-group.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ListFilterGroupComponent {

  constructor() { }

}
